import httpService from "services/api.service";

const BASE_URL = "/detail_customer";

export const getDetailKpiCustomer = async (payload, query) => {
  try {
    const res = await httpService.get(`${BASE_URL}/${payload.id}${query}`);
    return res;
  } catch (error) {
    throw error.message;
  }
};
